var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevertApproverModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6988 45.9855C37.8703 45.9855 37.1988 46.657 37.1988 47.4855V53.3387L23.5703 40.4965L37.1988 27.6645V33.5145C37.1988 34.343 37.8703 35.0145 38.6988 35.0145C45.6884 35.0145 50.0895 37.1843 52.8776 40.3525C55.6402 43.4917 56.9946 47.8087 57.4656 52.563C55.426 50.4871 53.1822 48.8384 50.2436 47.714C47.2074 46.5523 43.5213 45.9855 38.6988 45.9855ZM57.6177 52.921L58.9943 52.7983L57.5001 52.9301C57.5001 52.9305 57.5002 52.931 57.5002 52.9315L57.6119 52.9215L57.6177 52.921Z",
    fill: "white",
    stroke: "#AA198D",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 2C19.2437 2 2 19.2437 2 40.5C2 61.7563 19.2437 79 40.5 79C61.7563 79 79 61.7563 79 40.5C79 19.2437 61.7563 2 40.5 2Z",
    stroke: "#AA198D",
    strokeWidth: 2.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertApproverModal);
export default __webpack_public_path__ + "static/media/revertApproverModal.6ace7bbc1cb191cf56d2b3ab547126b5.svg";
export { ForwardRef as ReactComponent };